<template>
  <div class="columns is-gapless">
    <div class="column is-10">
      <div>
        <span
          class="spanreg hand"
          :class="classview(item, index)"
          v-for="(item, index) in items"
          :key="index"
          @click="selData(index)"
          ><strong>{{ item.nombre }}:</strong>
          <span class="fontMono"
            >{{ item.input
            }}<span v-if="item.inputrich"> - {{ item.inputrich }}</span></span
          >
        </span>
        <span v-show="costo" class="tag is-rounded is-link fontMono"
          >Costo: {{ costo | number(2) }}
        </span>
        <span
          v-show="existencia"
          class="
            tag
            is-rounded
            has-background-grey-light has-text-white
            fontMono
          "
          >Existencia: {{ existencia | number(2) }}
        </span>
      </div>
      <div class="datospruducto">
        <table cellspacing="0" style="width: 100%">
          <tr>
            <td style="width: 17%">
              <div style="float: left">
                <span>Cantidad</span>
              </div>
              <div style="float: right" class="fontMono has-text-right">
                <span>{{ cantidad | number(2) }}</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 25%">
              <div style="float: left">
                <span>Vlr unitario:</span>
              </div>
              <div style="float: right" class="fontMono has-text-right">
                <span>{{ punitario | number(2) }}</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 10%">
              <div style="float: left">
                <span>Dcto:</span>
              </div>
              <div style="float: right" class="fontMono has-text-right">
                <span>{{ descuento }}%</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 30%">
              <div style="float: left">Sub Total:</div>
              <div style="float: right" class="fontMono has-text-right">
                {{ subtotal | number(2) }}
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 10%">
              <div style="float: left">Iva:</div>
              <div style="float: right" class="fontMono has-text-right">
                {{ iva | number(2) }}%
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="column fontMono has-text-right">
      <span v-show="reg.tipo1 === '-'">-</span>
      {{ total | number(2) }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    reg: Object,
    items: Array,
    columna: Number,
    fila: Number,
    filaactual: Number,
  },
  computed: {
    ...mapState(["empresa"]),
    costo() {
      if (
        this.reg.objetoProducto &&
        this.reg.objetoProducto.datosProducto &&
        this.reg.objetoProducto.datosProducto[this.reg.bodega]
      ) {
        return this.reg.objetoProducto.datosProducto[this.reg.bodega]
          .ultimoCalculo.costo;
      } else {
        return false;
      }
    },
    existencia() {
      if (
        this.reg.objetoProducto &&
        this.reg.objetoProducto.datosProducto &&
        this.reg.objetoProducto.datosProducto[this.reg.bodega]
      ) {
        if (this.empresa.lote) {
          if (
            this.reg.objetoProducto.lote &&
            this.reg.batchcodigo &&
            this.reg.objetoProducto.lote[this.reg.bodega] &&
            this.reg.objetoProducto.lote[this.reg.bodega][this.reg.batchcodigo]
          ) {
            return this.reg.objetoProducto.lote[this.reg.bodega][
              this.reg.batchcodigo
            ].existencia;
          } else {
            return 0;
          }
        } else {
          return this.reg.objetoProducto.datosProducto[this.reg.bodega]
            .existencia.unidades;
        }
      } else {
        return false;
      }
    },
    iva() {
      if (this.reg.objetoProducto && this.reg.objetoProducto.linea) {
        return this.reg.objetoProducto.linea.vImpuesto;
      } else {
        return 0;
      }
    },
    total() {
      return this.subtotal + (this.subtotal * this.iva) / 100;
    },
    cantidad() {
      if (this.reg.cantidad) {
        const cantidad = parseFloat(this.reg.cantidad);
        if (isNaN(cantidad)) {
          return 0;
        } else {
          return cantidad;
        }
      } else {
        return 0;
      }
    },
    punitario() {
      if (this.reg.vlrUnitario) {
        return this.reg.vlrUnitario;
      } else {
        return 0;
      }
    },
    descuento() {
      if (this.reg.descuento) {
        const desc = parseFloat(this.reg.descuento);
        if (isNaN(desc)) {
          return 0;
        } else {
          return desc;
        }
      } else {
        return 0;
      }
    },
    valor() {
      return this.cantidad * this.punitario;
    },
    subtotal() {
      return this.valor - (this.valor * parseFloat(this.descuento)) / 100;
    },
  },
  methods: {
    selData(index) {
      this.$emit("columna", index + 1);
      this.$emit("fila", this.filaactual);
      setTimeout(function () {
        document.getElementById("inputItems").focus();
      }, 5);
    },
    classview(item, index) {
      let returned = {};
      if (item.css.status === "warning") {
        returned["has-text-warning"] = true;
      } else if (item.css.status === "danger") {
        returned["has-text-danger"] = true;
      } else if (item.css.status === "light") {
        returned["has-text-grey"] = true;
      }
      if (this.columna - 1 === index && this.fila === this.filaactual) {
        returned = {};
        returned["is-select"] = true;
      }
      return returned;
    },
  },
};
</script>

<style lang="scss" scoped>
.spanreg {
  padding: 3px 10px 3px 3px;
  border-radius: 6px;
}
.is-select {
  background-color: #5a5a5a;
  color: #ffffff;
}
.has-text-warning {
  color: #e6b800 !important;
}
.has-text-grey {
  color: #aeaeae !important;
}
.datospruducto {
  table,
  td,
  th {
    font-size: 14px;
    // border: 1px solid #eeeeee !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
    color: #8b8b8b !important;
  }
  tfoot {
    border: 0px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/facturar/componentsfra/Viewitems2.vue